/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import type {EditorThemeClasses} from 'lexical';

const theme: EditorThemeClasses = {
  blockCursor: 'RTE__blockCursor',
  characterLimit: 'RTE__characterLimit',
  code: 'RTE__code',
  codeHighlight: {
    atrule: 'RTE__tokenAttr',
    attr: 'RTE__tokenAttr',
    boolean: 'RTE__tokenProperty',
    builtin: 'RTE__tokenSelector',
    cdata: 'RTE__tokenComment',
    char: 'RTE__tokenSelector',
    class: 'RTE__tokenFunction',
    'class-name': 'RTE__tokenFunction',
    comment: 'RTE__tokenComment',
    constant: 'RTE__tokenProperty',
    deleted: 'RTE__tokenProperty',
    doctype: 'RTE__tokenComment',
    entity: 'RTE__tokenOperator',
    function: 'RTE__tokenFunction',
    important: 'RTE__tokenVariable',
    inserted: 'RTE__tokenSelector',
    keyword: 'RTE__tokenAttr',
    namespace: 'RTE__tokenVariable',
    number: 'RTE__tokenProperty',
    operator: 'RTE__tokenOperator',
    prolog: 'RTE__tokenComment',
    property: 'RTE__tokenProperty',
    punctuation: 'RTE__tokenPunctuation',
    regex: 'RTE__tokenVariable',
    selector: 'RTE__tokenSelector',
    string: 'RTE__tokenSelector',
    symbol: 'RTE__tokenProperty',
    tag: 'RTE__tokenProperty',
    url: 'RTE__tokenOperator',
    variable: 'RTE__tokenVariable',
  },
  embedBlock: {
    base: 'RTE__embedBlock',
    focus: 'RTE__embedBlockFocus',
  },
  hashtag: 'RTE__hashtag',
  heading: {
    h1: 'RTE__h1',
    h2: 'RTE__h2',
    h3: 'RTE__h3',
    h4: 'RTE__h4',
    h5: 'RTE__h5',
    h6: 'RTE__h6',
  },
  image: 'editor-image',
  indent: 'RTE__indent',
  link: 'RTE__link',
  list: {
    listitem: 'RTE__listItem',
    listitemChecked: 'RTE__listItemChecked',
    listitemUnchecked: 'RTE__listItemUnchecked',
    nested: {
      listitem: 'RTE__nestedListItem',
    },
    olDepth: [
      'RTE__ol1',
      'RTE__ol2',
      'RTE__ol3',
      'RTE__ol4',
      'RTE__ol5',
    ],
    ul: 'RTE__ul',
  },
  ltr: 'RTE__ltr',
  mark: 'RTE__mark',
  markOverlap: 'RTE__markOverlap',
  paragraph: 'RTE__paragraph',
  quote: 'RTE__quote',
  rtl: 'RTE__rtl',
  table: 'RTE__table',
  tableAddColumns: 'RTE__tableAddColumns',
  tableAddRows: 'RTE__tableAddRows',
  tableCell: 'RTE__tableCell',
  tableCellActionButton: 'RTE__tableCellActionButton',
  tableCellActionButtonContainer:
    'RTE__tableCellActionButtonContainer',
  tableCellEditing: 'RTE__tableCellEditing',
  tableCellHeader: 'RTE__tableCellHeader',
  tableCellPrimarySelected: 'RTE__tableCellPrimarySelected',
  tableCellResizer: 'RTE__tableCellResizer',
  tableCellSelected: 'RTE__tableCellSelected',
  tableCellSortedIndicator: 'RTE__tableCellSortedIndicator',
  tableResizeRuler: 'RTE__tableCellResizeRuler',
  tableSelected: 'RTE__tableSelected',
  text: {
    bold: 'RTE__textBold',
    code: 'RTE__textCode',
    italic: 'RTE__textItalic',
    strikethrough: 'RTE__textStrikethrough',
    subscript: 'RTE__textSubscript',
    superscript: 'RTE__textSuperscript',
    underline: 'RTE__textUnderline',
    underlineStrikethrough: 'RTE__textUnderlineStrikethrough',
  },
};

export default theme;